module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_green_09-10d69f2f227f3d59fe8f090713412e95.svg";